import Card from "./Card";
const TopStories = ({data})=>{
    return (
        <> 
        <h2 className="text-black text-2xl font-bold mt-4 md:text-3xl">{data.title}</h2>
        <div className="card flex gap-2 overflow-y-auto mt-3 ">
            {
                data?.news?.map((card,index)=>{
                    return <Card key={index} data={card}/>
                })
            }
        </div>
        </>
    )
}
export default TopStories;